import React from "react";
import FieldLabel from "../../../../components/label";
import ChipSelect from "../../../../components/chipSelect";
import AppointeeBankDetailsForm from "./bankForm";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import { withStyles } from "@mui/styles";
import { useStyles } from "../../indexFormStyles";
import { Box, Stack, Typography } from "@mui/material";
import { isAppointeeBankDetailsMissing } from "../../../../helpers/nominee";

function AppointeeBankDetails({
  classes: { accordianSection, contentScroller, formGroup },
  banks = [],
  errorMessage,
  form,
  handleAccordionChange,
  handleChange,
  handleChangeChipSelect,
  options,
  section,
  selectedBankOption = {},
  setSelectedBankOption,
  validateInputLength,
}) {
  return (
    <>
      <Box
        className={accordianSection}
        onClick={() =>
          handleAccordionChange("appointeeBank", section.appointeeBank)
        }
      >
        <Stack
          direction="row"
          gap={1}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {isAppointeeBankDetailsMissing(
            form,
            errorMessage,
            selectedBankOption
          ) && <NewReleasesOutlinedIcon />}
          {!isAppointeeBankDetailsMissing(
            form,
            errorMessage,
            selectedBankOption
          ) && <CheckCircleOutlineIcon sx={{ color: "green" }} />}
          <Typography variant="subtitle2">Appointee Bank Details</Typography>
        </Stack>
        <Box>
          {!section.appointeeBank && <ExpandMoreIcon fontSize="medium" />}
          {section.appointeeBank && <ExpandLessIcon fontSize="medium" />}
        </Box>
      </Box>

      {section.appointeeBank && (
        <Box p={1} mt={0} sx={{ height: "364px" }} className={contentScroller}>
          <Box className={formGroup} pt={0}>
            <FieldLabel label={"Appointee Bank Details*"} />
            <ChipSelect
              fieldname={"appointee_bank_details_available"}
              handleChange={handleChangeChipSelect}
              options={options.availableOrNot}
              selectedItem={form.appointee_bank_details_available}
              isMinWidth={true}
            />
          </Box>

          {form.appointee_bank_details_available === "Available" && (
            <>
              <Box className={formGroup} pt={0}>
                <FieldLabel label={"Same as the Owner of the Policy*"} />
                <ChipSelect
                  fieldname={"appointee_bank_details_same_as_owner"}
                  handleChange={handleChangeChipSelect}
                  options={options.sameOrDifferent}
                  selectedItem={form.appointee_bank_details_same_as_owner}
                  isMinWidth={true}
                />
              </Box>

              {form.appointee_bank_details_same_as_owner === "Different" && (
                <AppointeeBankDetailsForm
                  banks={banks}
                  errorMessage={errorMessage}
                  form={form}
                  handleChange={handleChange}
                  handleChangeChipSelect={handleChangeChipSelect}
                  options={options}
                  selectedBankOption={selectedBankOption}
                  setSelectedBankOption={setSelectedBankOption}
                  validateInputLength={validateInputLength}
                />
              )}
            </>
          )}
        </Box>
      )}
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(AppointeeBankDetails);
